/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TimeClockStopwatchIcon32Regular = forwardRef('TimeClockStopwatchIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M16 9a1 1 0 0 1 1 1v7a1 1 0 1 1-2 0v-7a1 1 0 0 1 1-1Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 0a1 1 0 1 0 0 2h3v2.038C8.288 4.548 3 10.157 3 17c0 7.18 5.82 13 13 13s13-5.82 13-13c0-3.23-1.178-6.185-3.128-8.458l2.085-2.085a1 1 0 0 0-1.414-1.414l-2.085 2.085A12.944 12.944 0 0 0 17 4.038V2h3a1 1 0 1 0 0-2h-8Zm4 6C9.925 6 5 10.925 5 17s4.925 11 11 11 11-4.925 11-11S22.075 6 16 6Z" })));
});
